import React from 'react';
import ReportService from '../service';
import { Row, Card, Col, ListGroupItem, ListGroup } from 'reactstrap';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { TotalRegister } from '../../../../../components/TotalRegister';
import { verifyRoles } from 'components/Authentication/VerifyRoles';
import ColumnHeader from '../../utils/ColumnHeader';

import {
  individual_column_style,
  individual_header_style
} from '../../../../../assets/styles/table_custom_style';
import { AudioStreamReportTelephony } from 'components/AudioController/AudioStream';
import { DownloadButton } from 'views/Report/Callcenter/CallMade/components/DownloadButton';

const itemStyle = { padding: '5px 0 0 20px' };

const analitical = ({
  isMultiDownload,
  selectedRows,
  handleOnSelect,
  handleOnSelectAll,
  showReports,
  quantity,
  extraDataFromAnalyticalReport
}) => {
  return (
    <>
      <Row>
        <div className="col">
          <div className="card-wrapper">
            {quantity >= 0 && <TotalRegister totalRegister={quantity} />}
            <Card>
              <ToolkitProvider
                data={showReports || []}
                keyField="uuid"
                columns={[
                  {
                    dataField: 'callDateStart',
                    text: <ColumnHeader title="Data início" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (Row) => {
                      const date = new Date(Row);
                      return `${date.toLocaleDateString(
                        'pt-br'
                      )} ${date.toLocaleTimeString('pt-br')}`;
                    }
                  },
                  {
                    dataField: 'callDateEnd',
                    text: <ColumnHeader title="Data final" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (Row) => {
                      const date = new Date(Row);
                      return `${date.toLocaleDateString(
                        'pt-br'
                      )} ${date.toLocaleTimeString('pt-br')}`;
                    }
                  },
                  {
                    dataField: 'clidNum',
                    text: <ColumnHeader title="origem" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'dst',
                    text: <ColumnHeader title="Destino" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'ddr',
                    text: <ColumnHeader title="DDR" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'centroDeCusto',
                    text: <ColumnHeader title="Centro de custo" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'carrier',
                    text: <ColumnHeader title="Operadora" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'dispositionFormated',
                    text: <ColumnHeader title="Status da chamada" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'transferIn',
                    text: <ColumnHeader title="Recebeu transferência de" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'transferOut',
                    text: <ColumnHeader title="Transferiu para" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'timeInCallFormated',
                    text: <ColumnHeader title="Tempo em ligação" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'waitingTimeFormated',
                    text: <ColumnHeader title="Tempo em espera" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'amdStatus',
                    text: <ColumnHeader title="AMD status" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'hangupCauseDescription',
                    text: <ColumnHeader title="Causa Desligamentos" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },

                  //trabalhar nesses dois pois ambos são audios
                  verifyRoles(['MONITORING_PBXIP_DOWNLOAD']) && {
                    dataField: 'download',
                    text: 'Download',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    // eslint-disable-next-line react/display-name
                    formatter: (_, row) => {
                      return (
                        <DownloadButton
                          row={row}
                          isCallMade={true}
                        ></DownloadButton>
                      );
                    }
                  },
                  verifyRoles(['MONITORING_PBXIP_LISTEN']) && {
                    dataField: 'listen',
                    text: 'Escutar',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,

                    // eslint-disable-next-line react/display-name
                    formatter: (_, row) => {
                      return (
                        <AudioStreamReportTelephony
                          ReportService={ReportService}
                          uniqueid={row.uniqueid}
                          disabled={
                            row.disposition === 'ANSWERED' ? false : true
                          }
                          reasonDisabled={
                            row.disposition === 'ANSWERED' ? '' : 'Não atendida'
                          }
                        />
                      );
                    }
                  }
                ]}
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    {isMultiDownload ? (
                      <BootstrapTable
                        selectRow={{
                          mode: 'checkbox',
                          selected: selectedRows.map((r) => r.uuid),
                          onSelect: handleOnSelect,
                          onSelectAll: handleOnSelectAll,
                          nonSelectable: showReports.map((row) => {
                            if (row.disposition !== 'ANSWERED') {
                              return row.uuid;
                            }
                          })
                        }}
                        bootstrap4={true}
                        bordered={false}
                        classes="align-items-center"
                        {...props.baseProps}
                      />
                    ) : (
                      <BootstrapTable
                        bootstrap4={true}
                        bordered={false}
                        classes="align-items-center"
                        {...props.baseProps}
                      />
                    )}
                  </div>
                )}
              </ToolkitProvider>
              {quantity > 0 && (
                <Row className="mb-3 mt-3">
                  <Col md="3">
                    <ListGroup flush>
                      <ListGroupItem disabled style={itemStyle}>
                        <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                          Chamadas atendidas:
                        </span>{' '}
                        {extraDataFromAnalyticalReport.quantityCallAnswer}
                      </ListGroupItem>
                      <ListGroupItem disabled style={itemStyle}>
                        <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                          Chamadas não atendidas:
                        </span>{' '}
                        {extraDataFromAnalyticalReport.quantityCallNoAnswer}
                      </ListGroupItem>
                      <ListGroupItem disabled style={itemStyle}>
                        <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                          Tempo médio de Serviço:
                        </span>{' '}
                        {
                          extraDataFromAnalyticalReport.averageServiceTimeFormated
                        }
                      </ListGroupItem>
                      <ListGroupItem disabled style={itemStyle}>
                        <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                          Tempo médio de Espera:
                        </span>{' '}
                        {
                          extraDataFromAnalyticalReport.waitingServiceTimeFormated
                        }
                      </ListGroupItem>
                    </ListGroup>
                  </Col>
                </Row>
              )}
            </Card>
          </div>
        </div>
      </Row>
    </>
  );
};
export default analitical;
